export default __webpack_public_path__ + "static/ampm--mobile@1x-e6476119b66c7c8807c82513b2b8f7bc.jpg";